import styled from 'styled-components'

export const Wrapper = styled.div`
  margin: 48px 0;
`

export const InputsContainer = styled.div`
  margin-bottom: 40px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 32px;
  grid-row-gap: 32px;
  align-items: center;

  input {
    margin-right: 32px;
  }

  @media (max-width: 1600px) {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 24px;
    grid-row-gap: 24px;

    input {
      margin-right: 24px;
    }
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
    grid-column-gap: 16px;
    grid-row-gap: 16px;

    input {
      margin-right: 16px;
    }
  }

  section {
    display: flex;
    align-items: center;
  }

  > input:last-child {
    margin-right: 0;
  }
`

export const IdentificationContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 32px;
  grid-row-gap: 32px;

  p {
    min-height: 50px;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.primary};
  }

  @media (max-width: 1600px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  section {
    display: flex;
    flex-direction: column;
  }

  input {
    margin-bottom: 18px;
  }
`
